import {Stack, Typography, Button, Box} from '@mui/material'
import { getWithdrawDetail } from '@/services/user'
import { useRequest } from "ahooks";
import {getUrlParams} from "@/utils/utils.js";
import {useEffect} from "react";
import RpIcon from "@/components/RpIcon";
import RouteConstant from "@/constant/RouteConstant";
import {useNavigate} from "react-router-dom";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";
import {useTranslation} from "react-i18next";
import {dispatch} from "@/redux/store";
import {setWithdrawInfo} from "@/redux/slices/assets";

const WithdrawSuccess= () => {
  const sn = getUrlParams('sn')
  const {t} = useTranslation()
  const navigate = useNavigate();
  const getWithdrawDetailReq = useRequest(async () => {
    const res = await getWithdrawDetail({sn})
    return res
  })

  useEffect(() => {
    getWithdrawDetailReq.runAsync()
  }, [])

  useEffect(() => {
    return () => {
      dispatch(setWithdrawInfo({
        address: '',
        amount: '',
        network: null,
      }))
    }
  }, []);

  return (<>
    <Stack
    sx={theme => {
      return {
        width: '100%',
        height: '100%'
        // paddingTop: theme.spacing(8),
      }
    }}
    >
      <Box direction="row">
        <SimpleHeader
          backEnable
          // title={t('withdraw_success')}
        />
        {/*<Button onClick={() => {*/}

        {/*}}>*/}
        {/*  <RpIcon icon={'account'} />*/}
        {/*  <Typography>Wallet</Typography>*/}
        {/*</Button>*/}
      </Box>
      <Stack direction="column" alignItems="center" sx={{
        marginTop:'64px',
        flex: 1,
        position: 'relative',

      }}>
        <RpIcon icon="check-circle" size={64} />
        <Typography
          variant="body2"
          color="textPrimary"
          sx={theme => { return {
            marginTop: theme.spacing(8),
            fontSize: theme.typography.pxToRem(28),
            fontWeight: 700
          }}}>{t('all_done')}</Typography>
        <Button
          sx={theme => {
            return {
              textDecoration: 'underline',
              color: theme.palette.text.secondary
            }
          }}
          onClick={() => {
            navigate(`${RouteConstant.USER_WITHDRAW_DETAIL}?sn=${sn}`)
          }}
        >{t('view_details')}</Button>
        <Box
        sx={{
          position: 'absolute',
          width: '100%',
          padding: '0 16px',
          bottom: '16px'
        }}
        >
          <Button
            size="large"
            variant="contained"
            fullWidth
            onClick={() => {
              navigate('/', {replace: true})
            }}
          >
            {t('got_it')}
          </Button>
        </Box>

      </Stack>
    </Stack>
  </>)
}

export default WithdrawSuccess